import store from '@/store';
import axios from 'axios';
import { BaseV1ApiService } from '@/services/backend/baseV1';

export class Fl44Purchases extends BaseV1ApiService {
    constructor() {
        super('purchases/fl44');
    }
    async getChangeLengthXml(id) {
        try {
            const response = await axios.get(this.getUrl(`${id}/change_length_xml`));
            return response.data;
        } catch (err) {
            this.handleErrors(err);
        }
    }

    async storeChangeLengthSigned(purchaseId, xml, certificate) {
        if (!certificate) {
            return false;
        }
        try {
            await axios.post(this.getUrl(`${purchaseId}/change_length`), {
                xml: xml,
                certificate: certificate
            });
            await store.dispatch('showSuccessToast', 'Продолжительность закупочной сессии изменена');
            return true;
        } catch (err) {
            this.handleErrors(err);
        }
    }

    async showExternalPurchase(id) {
        try {
            const response = await axios.get(this.getUrl(`external_purchase/${id}`));
            return response.data;
        } catch (error) {
            if (error.response.status === 404) {
                throw error;
            }
            this.handleErrors(error);
        }
    }

    async getXml(id) {
        try {
            const response = await axios.get(this.getUrl(`${id}/xml`));
            return response.data;
        } catch (err) {
            this.handleErrors(err);
        }
    }

    async storeSigned(id, data, xml, certificate = null, signedAttachments) {
        if (!certificate) {
            certificate = store.getters.currentParsedCertificate;
        }
        try {
            await axios.post(this.getUrl(`${id}/save`), {
                ...data,
                xml: xml,
                certificate: certificate,
                signed_attachments: signedAttachments
            });
            await store.dispatch('showSuccessToast', 'Закупочная сессия сформирована');
            return true;
        } catch (err) {
            this.handleErrors(err);
        }
    }

    async createDraft(payload) {
        try {
            const response = await axios.post(this.getUrl('create'), payload);
            await store.dispatch('showSuccessToast', 'Черновик извещения успешно сохранен');
            return response.data;
        } catch (err) {
            this.handleErrors(err);
        }
    }

    async updateDraft(id, payload) {
        try {
            const response = await axios.put(this.getUrl(`${id}/update`), payload);
            await store.dispatch('showSuccessToast', 'Черновик извещения успешно сохранен');
            return response.data;
        } catch (err) {
            this.handleErrors(err);
        }
    }

    async getDraft(id) {
        try {
            const response = await axios.get(this.getUrl(`${id}/edit`));
            return response.data;
        } catch (err) {
            this.handleErrors(err);
        }
    }

    async retrieveTemplate() {
        try {
            const response = await axios.get(this.getUrl('create'));
            return response.data;
        } catch (err) {
            this.handleErrors(err);
        }
    }

    async downloadPurchaseContractSupplementaryAgreementPdf(purchaseId, supplementaryAgreementId) {
        return axios.get(this.getUrl(`${purchaseId}/supplementary_agreements/${supplementaryAgreementId}/pdf`), { responseType: 'blob' });
    }

    async getExplanationRequests(purchaseId) {
        try {
            const response = await axios.get(this.getUrl(`${purchaseId}/explanation_requests`));
            return response.data;
        } catch (err) {
            this.handleErrors(err);
        }
    }

    async storeSignedDisagreement(purchaseId, contractId, path, payload, disagreementId = null) {
        try {
            await axios.post(this.getUrl(`${purchaseId}/supplementary_agreements/${contractId}/${path}/${disagreementId ? disagreementId : 'disagreement'}`), {
                ...payload
            });
            await store.dispatch('showSuccessToast', 'Действие выполнено успешно');
            return true;
        } catch (err) {
            this.handleErrors(err);
        }
    }

    async storeExplanationRequest(purchaseId, payload) {
        try {
            const response = await axios.post(this.getUrl(`${purchaseId}/explanation_requests`), payload);
            return response.data;
        } catch (err) {
            this.handleErrors(err);
            throw err;
        }
    }

    async updateExplanationRequest(purchaseId, requestId, payload) {
        try {
            const response = await axios.put(this.getUrl(`${purchaseId}/explanation_requests/${requestId}`), payload);
            return response.data;
        } catch (err) {
            this.handleErrors(err);
            throw err;
        }
    }
}
